// extracted by mini-css-extract-plugin
export var mutedDark = "#252222";
export var mutedLight = "gray";
export var primaryColor = "#fcb040";
export var primaryFont = "\"nimbus-sans\"";
export var secondaryColor = "#fc4040";
export var secondaryFont = "\"nimbus-sans-extended\"";